<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import Jitsi from "@/components/integrations/jitsi/Jitsi.vue";

definePage({
  meta: {
    layout: false,
    requiresAuth: false,
  },
});

const route = useRoute();
const roomId = computed(() => (route.params as { id: string }).id);
</script>

<template>
  <div
    class="tw:fixed tw:w-screen tw:h-screen tw:top-0 tw:left-0 tw:bg-surface tw:overflow-hidden tw:shadow-lg tw:z-layer-100"
  >
    <Jitsi :roomId />
  </div>
</template>
